export const carouselInicio = [
    {
        "imagen" : "/assets/imgs/banner/DSC04653_1.jpg"
    },
    {
        "imagen" : "/assets/imgs/banner/DSC04669_1_1jpg"
    },
    {
        "imagen" : "/assets/imgs/banner/DSC03696_2.jpg"
    },
]

export const carouselCepci = [
    {
        "imagen" : "/assets/imgs/DSC05666_1.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC00489.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC04244.JPG"
    },
    {
        "imagen" : "/assets/imgs/DSC03585.JPG"
    }
]